import { ReactNode } from 'react';

import {
  ChakraGridItem,
  ChakraSimpleGrid,
  EquipUITheme,
} from '@equip.health/ui';

import {
  DateSourceColSpan,
  EditStatusColSpan,
  GoalStatusColSpan,
  MeasuredAtColSpan,
  PositionColSpan,
  getNumColumns,
  getValueColSpan,
  getValueColumnTitle,
  isBloodPressureHeartRateTab,
  shouldShowClinicalProfilePositionTab,
} from './utils';
import { BLOOD_PRESSURE, HEART_RATE, PatientVitalsTabs } from '../../constants';

const { captionBold } = EquipUITheme.typography;

const ROW_ITEMS_HEIGHT = 32;
const HEADER_ROW_MARGIN_BOTTOM = 8;
export const HEADER_ROW_HEIGHT = ROW_ITEMS_HEIGHT + HEADER_ROW_MARGIN_BOTTOM;

const GridItem = ({
  children,
  colSpan,
}: {
  children: ReactNode;
  colSpan: number;
}) => (
  <ChakraGridItem
    {...captionBold}
    alignItems="center"
    color="secondary.50"
    colSpan={colSpan}
  >
    {children}
  </ChakraGridItem>
);

type HeaderRowProps = {
  tab: PatientVitalsTabs;
};

const HeaderRow = ({ tab }: HeaderRowProps) => {
  return (
    <ChakraSimpleGrid
      alignItems="center"
      background="neutral.background.secondary"
      borderRadius="16px"
      gap="16px"
      height={`${ROW_ITEMS_HEIGHT}px`}
      id="patient__key-vitals-list__header-row"
      marginBottom={`${HEADER_ROW_MARGIN_BOTTOM}px`}
      padding="8px 24px"
      templateColumns={
        isBloodPressureHeartRateTab(tab)
          ? '15% 8% 25% 12% 8% 10% auto'
          : `repeat(${getNumColumns(tab)}, 1fr)`
      }
    >
      {isBloodPressureHeartRateTab(tab) ? (
        <>
          <GridItem colSpan={getValueColSpan(tab)}>{BLOOD_PRESSURE}</GridItem>
          <GridItem colSpan={getValueColSpan(tab)}>{HEART_RATE}</GridItem>
        </>
      ) : (
        <GridItem colSpan={getValueColSpan(tab)}>
          {getValueColumnTitle(tab)}
        </GridItem>
      )}
      <GridItem
        colSpan={isBloodPressureHeartRateTab(tab) ? 1 : MeasuredAtColSpan}
      >
        Measured at
      </GridItem>
      {shouldShowClinicalProfilePositionTab(tab) && (
        <GridItem
          colSpan={isBloodPressureHeartRateTab(tab) ? 1 : PositionColSpan}
        >
          Position
        </GridItem>
      )}
      <GridItem
        colSpan={isBloodPressureHeartRateTab(tab) ? 1 : DateSourceColSpan}
      >
        Data source
      </GridItem>
      <GridItem
        colSpan={
          isBloodPressureHeartRateTab(tab)
            ? 1
            : EditStatusColSpan + GoalStatusColSpan
        }
      >
        Goal status
      </GridItem>
    </ChakraSimpleGrid>
  );
};

export default HeaderRow;
